(function () {
  function initSocialProof(root) {
    var stats = Array.prototype.slice.call(root.querySelectorAll("[data-rvrn-social-stat]"));
    var title = root.querySelector("[data-rvrn-social-title]");
    var copy = root.querySelector("[data-rvrn-social-copy]");
    var rail = root.querySelector("[data-rvrn-reach-stat-rail]");
    if (!stats.length || !title || !copy) return;

    function activate(stat) {
      (rail || root).classList.add("is-changing");
      stats.forEach(function (item) {
        item.classList.toggle("is-active", item === stat);
      });
      title.textContent = stat.getAttribute("data-title") || "";
      copy.textContent = stat.getAttribute("data-copy") || "";
      window.setTimeout(function () {
        (rail || root).classList.remove("is-changing");
      }, 140);
    }

    stats.forEach(function (stat) {
      stat.addEventListener("mouseenter", function () {
        activate(stat);
      });
      stat.addEventListener("focus", function () {
        activate(stat);
      });
      stat.addEventListener("click", function () {
        activate(stat);
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll("[data-rvrn-social-proof]").forEach(initSocialProof);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
